// import es from "./locales/es.json";
import en from "./locales/en.json";
import pt from "./locales/pt.json";
const locales = {
  en,
  pt,
};
export default locales;